import {fetch} from 'whatwg-fetch';
import queryString from 'query-string';

class Oauth2Service {
  constructor() {
    // eslint-disable-next-line
    this.apiUrl = process.env.TBX_API_URL || (window.AppENV && window.AppENV.TBX_API_URL);
  }

  authorize = async (config, data, encripted = false) => {
    const queryParams = {
      client_id: config.client_id,
      redirect_uri: config.redirect_uri,
      state: config.state,
      response_type: 'code',
      encripted
    };

    const result = await fetch(`${this.apiUrl}/oauth2/authorize?${queryString.stringify(queryParams)}`, {
      method: 'POST',
      body: JSON.stringify({
        msisdn: data.msisdn,
        pin: data.pin,
        terra_key: config.terra_key,
        grant_type: 'pin'
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

    return result;
    }

  sendPin = async (config, msisdn, recaptchaToken) => {
    const result = await fetch(`${this.apiUrl}/vivo/${config.client_id}/pin`, {
      method: 'POST',
      body: JSON.stringify({
        msisdn,
        terra_key: config.terra_key,
        'g-recaptcha-response': recaptchaToken
      }),
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((res) => res.json());

    return result;
  }

}

export default new Oauth2Service();



// WEBPACK FOOTER //
// ./src/services/Oauth2Service.js